import React from 'react';

interface MoneyProps {
  amount: number | string;
  currency?: string;
  className?: string;
}

const Money: React.FC<MoneyProps> = ({ amount, currency = 'RWF', className = '' }) => {
  const num = Number(amount || 0);
  const formatted = num.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  return <span className={`font-mono ${className}`}>{formatted} {currency}</span>;
};

export default Money;
